import $ from 'jquery';
import Viewport from './Viewport';

const defaults = {
  selector: 'a.depth-1',
};

function MobileMenu(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.selector = this.settings.selector;
  this.$roots = this.getRootMenus();
  this.onClick = $.proxy(this.onClick, this);
  this.mobileChange = $.proxy(this.mobileChange, this);
  this.desktopChange = $.proxy(this.desktopChange, this);
  this.isMobile = false;
  this.init();
}

MobileMenu.prototype = {
  init() {
    this.resetMenu();
    Viewport.onMobileChange(this.mobileChange);
    Viewport.onDesktopChange(this.desktopChange);
    Viewport.update();
    this.addListeners();
    this.displayActiveMenus();
  },
  getRootMenus() {
    return $(this.selector, this.element);
  },
  resetMenu() {
    this.$roots.each((i, element) => {
      $(element).removeClass('expand');
    });
  },
  onClick(event) {
    const clickedActivator = $(event.target).is('.menu-link');
    if (this.isMobile && clickedActivator) {
      $(event.currentTarget).toggleClass('expand');
      event.preventDefault();
    }
  },
  displayActiveMenus() {
    $(`.active-trail ${this.selector}:not(.active)`, this.element).addClass('expand');
  },
  addListeners() {
    this.$roots.bind('click', this.onClick);
  },
  mobileChange() {
    this.isMobile = true;
  },
  desktopChange() {
    this.isMobile = false;
  },
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./MobileMenu.js